import React from 'react';

const SvgKe = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="KE_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path
        d="M3.333 14c1.334 0 3.334-2.617 3.334-6.667S4.667.667 3.333.667C2 .667 0 3.283 0 7.333 0 11.383 2 14 3.333 14z"
        id="KE_svg__c"
      />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="KE_svg__g">
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#F0F0F0" offset="100%" />
      </linearGradient>
      <path
        d="M3.333 9.333c-.368 0-.666-.895-.666-2 0-1.104.298-2 .666-2 .369 0 .667.896.667 2 0 1.105-.298 2-.667 2zm0-4c-.368 0-.666-1.194-.666-2.666 0-1.473.298-2.667.666-2.667C3.702 0 4 1.194 4 2.667c0 1.472-.298 2.666-.667 2.666zm0 9.334c-.368 0-.666-1.194-.666-2.667 0-1.473.298-2.667.666-2.667C3.702 9.333 4 10.527 4 12c0 1.473-.298 2.667-.667 2.667z"
        id="KE_svg__f"
      />
      <filter
        x="-37.5%"
        y="-3.4%"
        width="175%"
        height="113.1%"
        filterUnits="objectBoundingBox"
        id="KE_svg__e"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="KE_svg__b" fill="#fff">
        <use xlinkHref="#KE_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#KE_svg__a" />
      <path fill="#262626" mask="url(#KE_svg__b)" d="M0 0h28v5.333H0z" />
      <path fill="#018301" mask="url(#KE_svg__b)" d="M0 14.667h28V20H0z" />
      <path fill="#FFF" mask="url(#KE_svg__b)" d="M0 5.333h28v9.333H0z" />
      <path fill="#DC0808" mask="url(#KE_svg__b)" d="M0 6.667h28v6.667H0z" />
      <g mask="url(#KE_svg__b)">
        <g transform="translate(10.667 2.667)">
          <mask id="KE_svg__d" fill="#fff">
            <use xlinkHref="#KE_svg__c" />
          </mask>
          <use fill="#BC0000" xlinkHref="#KE_svg__c" />
          <ellipse
            fill="#262626"
            mask="url(#KE_svg__d)"
            cx={-2}
            cy={7.333}
            rx={3.333}
            ry={7.333}
          />
          <ellipse
            fill="#262626"
            mask="url(#KE_svg__d)"
            cx={8.667}
            cy={7.333}
            rx={3.333}
            ry={7.333}
          />
          <g mask="url(#KE_svg__d)">
            <use fill="#000" filter="url(#KE_svg__e)" xlinkHref="#KE_svg__f" />
            <use fill="url(#KE_svg__g)" xlinkHref="#KE_svg__f" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgKe;
